/** Matches community invite URLs with or without protocol (e.g. app.canadawaleyar.com/community/invite/TOKEN). */
export const COMMUNITY_INVITE_PATH_REGEX =
  /(?:https?:\/\/)?(?:[\w.-]+(?::\d+)?)\/community\/invite\/([A-Za-z0-9_-]+)/gi;

export interface ParsedCommunityInviteUrl {
  token: string;
  href: string;
  raw: string;
  start: number;
  end: number;
}

export function normalizeCommunityInviteHref(raw: string, token: string): string {
  const trimmed = raw.trim();
  const withProtocol = /^https?:\/\//i.test(trimmed)
    ? trimmed
    : trimmed.startsWith('localhost') || trimmed.startsWith('127.')
      ? `http://${trimmed}`
      : `https://${trimmed}`;

  try {
    const parsed = new URL(withProtocol);
    return `${parsed.origin}/community/invite/${token}`;
  } catch {
    if (typeof window !== 'undefined' && window.location?.origin) {
      return `${window.location.origin}/community/invite/${token}`;
    }
    return `/community/invite/${token}`;
  }
}

export function extractCommunityInviteFromText(text: string): ParsedCommunityInviteUrl | null {
  COMMUNITY_INVITE_PATH_REGEX.lastIndex = 0;
  const match = COMMUNITY_INVITE_PATH_REGEX.exec(text);
  if (!match?.[1]) return null;

  const raw = match[0];
  const token = match[1];
  return {
    token,
    href: normalizeCommunityInviteHref(raw, token),
    raw,
    start: match.index,
    end: match.index + raw.length,
  };
}

export function stripCommunityInviteUrls(text: string): string {
  return text
    .replace(COMMUNITY_INVITE_PATH_REGEX, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
}
